import {
  IImpersonationStartResponse,
  IImpersonationStatus,
  IPlatformBusinessListItem,
} from '@torim-app/types';
import { platformUrlBuilder } from '@app/api/utils';

export class PlatformApi {
  static async listBusinesses(search?: string): Promise<IPlatformBusinessListItem[]> {
    const url = platformUrlBuilder(search ? { search } : {}, 'businesses');
    const response = await fetch(url, {
      method: 'get',
      headers: { 'content-type': 'application/json' },
    });
    if (response.status === 401 || response.status === 403) throw 'FORBIDDEN';
    if (!response.ok) throw 'Failed to load businesses';
    return await response.json();
  }

  static async impersonate(bid: string): Promise<IImpersonationStartResponse> {
    const url = platformUrlBuilder({}, `impersonate/${bid}`);
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
    });
    if (response.status === 401 || response.status === 403) throw 'FORBIDDEN';
    if (!response.ok) throw 'Failed to start impersonation';
    return await response.json();
  }

  static async stopImpersonation(): Promise<void> {
    const url = platformUrlBuilder({}, 'impersonation/stop');
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
    });
    if (!response.ok) throw 'Failed to stop impersonation';
  }

  static async getStatus(): Promise<IImpersonationStatus> {
    const url = platformUrlBuilder({}, 'impersonation/status');
    const response = await fetch(url, {
      method: 'get',
      headers: { 'content-type': 'application/json' },
    });
    if (!response.ok) return { isImpersonation: false };
    return await response.json();
  }
}
